// Utility to determine if All Operations should be hidden for a given route
import { ROUTE } from '../constants/routes';

// Config for routes where All Operations should be hidden
const ALL_OPERATIONS_HIDDEN_CONFIG: Record<string, boolean> = {
  [ROUTE.FieldSelection]: false,
  [ROUTE.DataInbox]: true,
  [ROUTE.FixitTool]: true,
  [ROUTE.Dashboard]: false,
  [ROUTE.Dmb]: false,
  [ROUTE.Partners]: false,
  [ROUTE.Reports]: false,
  [ROUTE.CropPlanning]: false,
  [ROUTE.Programs]: false,
  [ROUTE.DataHub]: false,
  [ROUTE.VariableRate]: false,
  [ROUTE.ScriptCreator]: false,
  [ROUTE.Settings]: false,
  [ROUTE.InSeason]: false,
};

export function shouldHideAllOperations(route: string): boolean {
  const baseRoute = `/${route.split('/')[1]}`;
  return !!ALL_OPERATIONS_HIDDEN_CONFIG[baseRoute];
}
